import React from "react";

const PrivacyPolicy = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title: "Privacy Policy",
      subtitle:
        "Your privacy is important to us. This Privacy Policy outlines how our firm collects, uses, and safeguards your personal information.",

      s1: "Information We Collect",
      s1d:
        "We may collect personal information including your name, phone number, email address, financial information, identification documents, and insurance-related details when you interact with our website or services.",

      s2: "How We Use Your Information",
      s2d:
        "Your information is used to process applications, provide consultations, respond to inquiries, improve customer service, and comply with legal requirements.",

      s3: "Data Security",
      s3d:
        "We implement industry-standard security measures to protect your data from unauthorized access or misuse.",

      s4: "Sharing of Information",
      s4d:
        "We do not sell your personal data. Information may be shared with trusted partners or authorities only when required.",

      s5: "Cookies & Website Usage",
      s5d:
        "Our website may use cookies to enhance user experience and improve functionality.",

      s6: "Your Rights",
      s6d:
        "You may request access, correction, or deletion of your personal data at any time.",

      s7: "Policy Updates",
      s7d:
        "We may update this policy when regulations change. Updates will appear on this page.",
    },

    zh: {
      title: "隐私政策",
      subtitle:
        "我们重视您的隐私。本政策说明我们如何收集、使用并保护您的个人信息。",

      s1: "收集的信息",
      s1d:
        "当您使用我们的网站或服务时，我们可能会收集姓名、电话、邮箱及相关财务信息。",

      s2: "信息用途",
      s2d:
        "您的信息用于提供咨询、处理申请、改进服务及符合法规要求。",

      s3: "数据安全",
      s3d:
        "我们采用行业标准安全措施保护您的数据。",

      s4: "信息共享",
      s4d:
        "我们不会出售您的信息，仅在必要时与合作伙伴或监管机构共享。",

      s5: "Cookies",
      s5d:
        "本网站可能使用 cookies 提升用户体验。",

      s6: "您的权利",
      s6d:
        "您可随时请求访问、更正或删除您的个人信息。",

      s7: "政策更新",
      s7d:
        "本政策可能更新，最新版本将发布在本页面。",
    },
  };

  return (
    <section className="bg-gray-50 py-12">
      <div className="max-w-5xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-10">

          <h1 className="text-4xl font-bold text-[#154059] mb-4">
            {text[lang].title}
          </h1>

          <p className="text-gray-600 max-w-3xl mx-auto">
            {text[lang].subtitle}
          </p>

        </div>


        <div className="bg-[#c09f7c33] shadow-lg p-8 space-y-8">


          <Block t={text[lang].s1} d={text[lang].s1d} />
          <Block t={text[lang].s2} d={text[lang].s2d} />
          <Block t={text[lang].s3} d={text[lang].s3d} />
          <Block t={text[lang].s4} d={text[lang].s4d} />
          <Block t={text[lang].s5} d={text[lang].s5d} />
          <Block t={text[lang].s6} d={text[lang].s6d} />
          <Block t={text[lang].s7} d={text[lang].s7d} />


        </div>

      </div>
    </section>
  );
};

export default PrivacyPolicy;



function Block({ t, d }) {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-[#154059] mb-3">
        {t}
      </h2>
      <p className="text-gray-600 leading-relaxed">
        {d}
      </p>
    </div>
  );
}